var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification"},[_c('article',[_c('b-table',{attrs:{"data":_vm.tests,"columns":_vm.columns,"loading":_vm.loading,"hoverable":""},on:{"click":_vm.open}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }